import { Directive, ElementRef, EventEmitter, Input, Output } from '@angular/core';

import { fromEvent, Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';

import { RtPlatform } from '../platform/platform';

type EventPair = { touchEvtType: string; mouseEvtType: string };

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[interactionEvent]',
})
export class InteractionEventDirective {
  @Input('interactionEvent') public set eventPair(value: EventPair) {
    this.eventPair$.next(value || this.defaultEventPair);
  }
  @Output() public interaction: EventEmitter<Event> = new EventEmitter();

  private ngOnDestroy$: Subject<void> = new Subject<void>();
  private eventPair$: Subject<EventPair> = new Subject();

  private readonly defaultEventPair: EventPair = {
    touchEvtType: 'touchend',
    mouseEvtType: 'click',
  };

  constructor(private elRef: ElementRef, private platform: RtPlatform) {
    this.eventPair$
      .pipe(
        switchMap((eventPair: EventPair) =>
          fromEvent(
            this.elRef.nativeElement,
            this.platform.IS_MOBILE ? eventPair.touchEvtType : eventPair.mouseEvtType,
          ),
        ),
        takeUntil(this.ngOnDestroy$.asObservable()),
      )
      .subscribe((e: Event) => {
        this.interaction.emit(e);
      });

    this.eventPair$
      .pipe(
        switchMap((eventPair: EventPair) =>
          fromEvent(
            this.elRef.nativeElement,
            this.platform.IS_MOBILE ? eventPair.mouseEvtType : eventPair.touchEvtType,
          ),
        ),
        takeUntil(this.ngOnDestroy$),
      )
      .subscribe((event: Event) => {
        event.stopImmediatePropagation();
      });
  }

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }
}
